"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../utils/constants");
var _upsellUtils = require("../../utils/upsellUtils");
var _AccessoryParser = require("./AccessoryParser");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var typeMap = {
  accessory: _constants.PRODUCT_TYPES.ACCESSORY,
  insurance: _constants.PRODUCT_TYPES.INSURANCE
};
var parsePricing = function parsePricing(product) {
  return product.productOfferingPrice.map(function (priceItem, index) {
    var _priceItem$productOff, _priceItem$productOff2;
    return {
      priceValue: priceItem.price.value,
      priceUnit: priceItem.price.unit,
      priceType: priceItem.priceType,
      durationAmount: (_priceItem$productOff = priceItem.productOfferingTerm[index]) === null || _priceItem$productOff === void 0 ? void 0 : _priceItem$productOff.duration.amount,
      durationUnit: (_priceItem$productOff2 = priceItem.productOfferingTerm[index]) === null || _priceItem$productOff2 === void 0 ? void 0 : _priceItem$productOff2.duration.units
    };
  }).sort(function (a, b) {
    return a.priceValue - b.priceValue;
  })[0];
};
var parseUpsellOfferings = function parseUpsellOfferings(offerings, upsellSettings) {
  var priceFormatedOfferings = offerings.map(function (offering) {
    offering.price = parsePricing(offering);
    offering.productType = typeMap[offering.category[0].name];
    var productName = offering.name;
    var productCategory = offering.category[0].id;
    var topFeaturesCharacteristics = upsellSettings.upsellTypes.find(function (type) {
      return type.value === productCategory;
    }).characteristics;
    var topFeaturesList = [];
    offering.productSpecification.productSpecCharacteristic.filter(function (characteristic) {
      var itsTopFeature = topFeaturesCharacteristics.includes(characteristic.name);
      return itsTopFeature;
    }).forEach(function (spec) {
      spec.productSpecCharacteristicValue.forEach(function (value) {
        var text = typeof value.value === 'boolean' ? "".concat(spec.name) : value.value;
        value.value && topFeaturesList.push(text);
      });
    });
    var priceType = offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].priceType;
    var upfrontPriceValue, recurringPriceValue, recurringPriceTerm;
    if (priceType === _constants.PRICE_TYPES.ADVANCE_PAYMENT) {
      var _parsePriceOffering = (0, _AccessoryParser.parsePriceOffering)(offering),
        totalPrice = _parsePriceOffering.totalPrice,
        minUpfront = _parsePriceOffering.minUpfront,
        maxTerm = _parsePriceOffering.maxTerm;
      var _calculateUpsellPayme = (0, _upsellUtils.calculateUpsellPayment)(totalPrice.value, minUpfront.value, maxTerm.value),
        upfront = _calculateUpsellPayme.upfront,
        monthlyPrice = _calculateUpsellPayme.monthlyPrice;
      upfrontPriceValue = upfront;
      recurringPriceValue = monthlyPrice;
      recurringPriceTerm = maxTerm.unitOfMeasure;
    } else {
      upfrontPriceValue = priceType === _constants.PRICE_TYPES.UP_FRONT ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].price.value : 0;
      recurringPriceValue = priceType === _constants.PRICE_TYPES.RECURRING ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].price.value : 0;
      recurringPriceTerm = priceType === _constants.PRICE_TYPES.RECURRING ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].productOfferingTerm[0].duration.units : null;
    }
    var paymentOptions = (0, _upsellUtils.createPaymentOptions)(recurringPriceValue, recurringPriceTerm, '', upfrontPriceValue);
    return _objectSpread(_objectSpread({}, offering), {}, {
      productName: productName,
      topFeaturesList: topFeaturesList,
      paymentOptions: paymentOptions,
      upfrontPriceValue: upfrontPriceValue,
      recurringPriceValue: recurringPriceValue,
      recurringPriceTerm: recurringPriceTerm
    });
  });
  return priceFormatedOfferings;
};
var _default = parseUpsellOfferings;
exports.default = _default;